module.exports = __webpack_public_path__ + "static/media/TradeGothicLTStd-Cn18.90c5331a.otf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/fonts/TradeGothic/TradeGothicLTStd-Cn18.otf
// module id = 723
// module chunks = 0